import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSidemenuFunding = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 0) scale(1.5)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M6.19541 2.51062C8.20902 0.496073 11.4748 0.496851 13.4892 2.51062C15.5036 4.52438 15.5036 7.79043 13.4892 9.80497M11.3162 9.84153C11.3162 12.6905 9.00681 15 6.15808 15C3.30935 15 1 12.6905 1 9.84153C1 6.99258 3.30935 4.68305 6.15808 4.68305C9.00681 4.68305 11.3162 6.99258 11.3162 9.84153Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgSidemenuFunding);
export default ForwardRef;
